import { SearchInput } from "components/Input";
import { useTranslation } from "react-i18next";

import { TransientJobLogChips } from "./TransientJobLogChips";

type TransientJobLogRoomFilterProps = {
  availableRooms: readonly string[];
  isSelected: (room: string) => boolean;
  onSearch: (value: string) => void;
  onToggle: (room: string) => void;
  search: string;
  selectedRooms: readonly string[];
};

export const TransientJobLogRoomFilter = ({
  availableRooms,
  isSelected,
  onSearch,
  onToggle,
  search,
  selectedRooms,
}: TransientJobLogRoomFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-[60vh] w-80 shrink-0 flex-col items-stretch gap-3">
      <SearchInput
        debounceTime={300}
        height="4rem"
        label={t("Execution.transient.jobDetails.searchRooms")}
        onChange={(event) => onSearch(event.target.value)}
        type="search"
        value={search}
        width="100%"
      />
      {selectedRooms.length > 0 ? (
        <TransientJobLogChips isOn={() => true} onToggle={onToggle} values={selectedRooms} />
      ) : null}
      <div className="min-h-0 w-full flex-1 overflow-auto">
        {availableRooms.length === 0 && selectedRooms.length === 0 ? (
          <p className="font-ds-body-regular-sm py-2 text-lds-foreground-muted">
            {t("Execution.transient.jobDetails.noMatchingRooms")}
          </p>
        ) : (
          <TransientJobLogChips isOn={isSelected} onToggle={onToggle} values={availableRooms} />
        )}
      </div>
    </div>
  );
};
